module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"mocha","commonjs2":"mocha"}
 ** module id = 5
 ** module chunks = 0
 **/